// extracted by mini-css-extract-plugin
export var fullWidthButton = "_f8-0";